import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class LandingPage extends Component {


    render(){
        const {t} = this.props;
        return(
            <div className="section-entry">
                <h2 className="page-heading">
                    {t("pages.profile.manageAccount")}
                </h2>
                <p className="page-desc">
                    {t("pages.profile.landingDesc")}
                </p>
                <Row noGutters className="cards">
                    <Col className="cards__box">
                        <Row className="cards__box-row two-factor-icon">
                            <Col sm={{span:8}}>
                                <div className="top-section">
                                    <p className="cards__box-row-title">
                                        {t("pages.profile.mfaAuthentication")}
                                    </p>
                                </div>
                                <div className="bottom-section">
                                    <p className="cards__box-row-text my-2">
                                        {t("pages.profile.twoFactorDesc")}
                                    </p>
                                    <a className="cards__box-row-link mt-3" href="https://portal.ct.gov/ctidentity/mfa-faq?language=en_US" target="_blank">
                                        {t("pages.login.readMoreMFA")}
                                    </a>
                                </div>
                            </Col>
                        </Row>
                        <Row className="cards__box-row security">
                            <Col>
                                <p className="cards__box-row-title">
                                    {t("pages.login.security")}
                                </p>
                                <p className="cards__box-row-text my-2">
                                    {t("pages.login.securityDesc")}
                                </p>
                                <a className="cards__box-row-link mt-3" href="https://portal.ct.gov/ctidentity/mfa-faq?language=en_US" target="_blank">
                                    {t("pages.login.readMore")}
                                </a> 
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withTranslation()(LandingPage);